import { createSlice } from '@reduxjs/toolkit';
import { datastreamsApi } from '~/api/datastreams-api';

// Define the Conversation type
export interface Datastream {
  id: string;
  name: string;
  referrer: string;
  owner: string;
  settings: any;
  state: string;
  status: string;
  type: string;
  state_changed: string;
  state_message: string | null;
  state_error_code: string | null;
  created: string;
  updated: string;
}

// Define the state interface for datastream
interface DatastreamsState {
  datastreams: Datastream[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: DatastreamsState = {
  datastreams: [],
  status: 'idle',
  error: null,
};

const datastreamsSlice = createSlice({
  name: 'datastreams',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle getDatastreams endpoint actions from RTK Query
    builder
      .addMatcher(datastreamsApi.endpoints.getDatastreams.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(datastreamsApi.endpoints.getDatastreams.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.datastreams = action.payload;
      })
      .addMatcher(datastreamsApi.endpoints.getDatastreams.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch datastreams';
      });
  },
});

export default datastreamsSlice.reducer;
